export default {
  setQuizResults(state, data) {
    state.quizResults = data;
  },

  setResult(state, data) {
    state.result = data;
  },
};
